import type { ZipOption } from '../../../../backend/src/types/types';
export type { ZipOption } from '../../../../backend/src/types/types';

export class ApiError extends Error {
  code: number;
  message: string;

  constructor(code: number, message: string) {
    super(message);
    this.code = code;
    this.message = message;
  }
}
export interface Pagination {
  currentPage: number;
  filteredPages: number | null;
  pageSize: number;
  processedCount: number;
  totalCount: number;
  totalPages: number;
}

export interface DocumentZipFilters {
  searchQuery?: string;
  processed?: boolean;
  extensions?: string[];
  startDate?: string;
  endDate?: string;
  documentTypes?: string[];
  documentIssues?: string[];
  hasKeyFacts?: boolean;
  hasRelevantFacts?: boolean;
  isPleading?: boolean;
  metadataFilters?: { field: string; value: string | number | string[] | number[] }[];
  folderId?: string;
  docIds?: string[];
  zipContent?: ZipOption;
  docChronologyId?: string;
}

export enum QueryEntity {
  UsageStats,
  UsageActivityBreakdown,
  ActiveRuns,
  AllActiveRuns,
  ApideckAllConnections,
  ApideckSession,
  AuditTrail,
  RecentActivity,
  Case,
  DocChronologies,
  DocChronology,
  DocChronologyDocs,
  DocChronologyBundleItems,
  DocBundleItems,
  SubsetDocsCount,
  SubsetDocs,
  SubsetFacts,
  SubsetFactAllIds,
  SubsetInconsistencies,
  SubsetIssues,
  SubsetPersons,
  PersonNames,
  Subset,
  Subsets,
  Chronologies,
  Chronology,
  ChronologyFacts,
  ChronologyVisualisation,
  Chunk,
  Doc,
  DocIds,
  FilteredDocIds,
  DocTypes,
  SubsetOverview,
  DocIssues,
  DocTotals,
  DocSubsetFacts,
  DocumentChunkMatches,
  Fact,
  FactDetails,
  KimChronologyFactDetails,
  FailedDocs,
  Files,
  InconsistenciesByIds,
  InconsistencyReport,
  InconsistencyReports,
  Matter,
  MatterSuggestedContext,
  MatterParties,
  Matters,
  MatterOverview,
  MatterDocFilterValues,
  MatterDocsWithCases,
  MatterChronologies,
  MatterDocChronologies,
  Messages,
  Organisation,
  OrganisationById,
  OrganisationFeedback,
  Organisations,
  OrgUsageData,
  OrgCreditByMatter,
  PendingInvites,
  PermissionOverrides,
  PromptTemplates,
  ProcessingDocs,
  PresignedGetDocumentImage,
  PresignedGetDocumentPDF,
  DocumentPageText,
  RecentSubsets,
  GlobalRecentSubsets,
  RecentMatters,
  RelativityDocumentCount,
  SubsetSuggestions,
  SubsetSuggestion,
  RelativityLists,
  RelativityWorkspaces,
  RelativityWorkspaceFields,
  RelativityFieldChoices,
  RelativityFieldMapping,
  MetadataFilterOptions,
  ConfiguredRelativityWorkspaces,
  RelativitySyncPreview,
  RelativitySyncStatus,
  Roles,
  Runs,
  Summary,
  CaseIssues,
  Threads,
  KimArtifacts,
  KimPublishedArtifacts,
  KimMessages,
  KimThread,
  KimThreadExistsInNewKim,
  KimThreadFile,
  KimThreads,
  MatterKimThreads,
  ThreadStatus,
  PublishedThreads,
  Transcript,
  TranscriptSubfact,
  Transcripts,
  UploadHistory,
  ExportStatus,
  FileHistoryStats,
  SkippedFiles,
  DeletedFiles,
  DeletionStatus,
  ProcessedDocs,
  NotProcessedDocs,
  UploadProgress,
  UserRoles,
  Users,
  User,
  SeatBasedUsage,
  SubsetDocIds,
  ProceduralTimelineUploadEligibility,
  ProceduralTimelineEvents,
  ProceduralTimelineSuggestions,
  ProceduralTimelineFile,
  ProceduralTimelineHolidays,
  ProceduralTimelineStagedDuplicate,
  MatterUsers,
  LoadFileImports,
  LoadFileImportReport,
  LoadFileImportStatus,
  DocumentFilenames,
}
